import { render, staticRenderFns } from "./AsignacionInterpretaciones.vue?vue&type=template&id=33a15f24"
import script from "./AsignacionInterpretaciones.vue?vue&type=script&lang=js"
export * from "./AsignacionInterpretaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports